@use "~theme/typographyV2" as typography;

.anchorButton {
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  color: var(--blue-01);

  &:focus {
    outline: 2px solid var(--highlight-blue-at-30);
  }
}

.standard {
  @include typography.button-large;
  border-bottom: 1px solid currentcolor;
  text-decoration: none;

  &:hover {
    border-color: var(--highlight-blue);
  }
}

.inline {
  @include typography.body;
  border: none;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 600;
  color: var(--brand-indigo);
  font-size: 14px;

  &:hover {
    border: none;
    color: var(--highlight-blue);
  }
}
